module.exports = __webpack_public_path__ + "img/emp5-3.6d364e29.jpg";